// extracted by mini-css-extract-plugin
export default {"title":"e623137d1d","inner_title":"_275f9aeb06","charge_btn":"_4ddae51363"};